// extracted by mini-css-extract-plugin
export var activeFilterButton = "_ma-c";
export var backButton = "_ma-4";
export var backIcon = "_ma-5";
export var chevronShortcut = "_ma-6";
export var container = "_ma-1";
export var editor = "_ma-8";
export var editorWrapper = "_ma-7";
export var prefix = "_ma-2";
export var searchIcon = "_ma-3";
export var suffix = "_ma-9";
export var suffixContent = "_ma-a";
export var suffixText = "_ma-b";
export var wrapper = "_ma-0";